/**
 * @license BCP
 * (c) 2016 Openprovider. http://openprovider.eu
 * @author Igor Dolzhikov idolzhikov@openprovider.nl
 * License: MIT
 */
(function() {'use strict';

/**
 * @ngdoc module
 * @name import
 * @description
 *
 * # import
 *
 * The `import` module provides import data from CSV/JSON files.
 */
angular.module("import", [])
/**
 * @ngdoc controller
 * @name importCtrl
 * @requires $location, $timeout, $aside, b17Service, userCache, auth, exportService
 *
 * @description
 * Settings Controller
 */
  .controller("importCtrl", function (
    $scope, $location, $timeout, $aside, b17Service, userCache, auth, exportService, exportToCsv) {

    var ctrl = this;

    ctrl.ld = _;

    // init error and info messages
    ctrl.errorMessage = null;
    ctrl.infoMessage = null;

    ctrl.location = $location.path();

    ctrl.selectedSection = userCache.get('importSelectedSection');
    
    ctrl.data = {
      products: {
        upload: [],
        exist: [],
      },
      providers: {
        upload: [],
        exist: [],
      },
      prices: {
        upload: [],
        exist: [],
      },
      groups: [],
      versions: []
    };

    // get b17 config
    b17Service.getConfig().then(function (config) {
      if (config.data && config.data.data) {
        ctrl.data.config = config.data.data.results[0];
      } else {
        checkErrorCodeMessage();
      }
    });

    // get editions data (price versions without promotions)
    b17Service.getEditions().then(function (editions) {
      if (editions.data && editions.data.data) {
        ctrl.data.versions = _.sortBy(editions.data.data.results, 'number');
      } else {
        checkErrorCodeMessage();
      }
    });

    // get groups data
    b17Service.getGroups().then(function (groups) {
      if (groups.data && groups.data.data) {
        ctrl.data.groups = _.sortBy(groups.data.data.results, 'id');
      } else {
        checkErrorCodeMessage();
      }
    });

    // clear error message
    ctrl.dismissError = function() {
      ctrl.errorMessage = null;
    };

    // clear info message
    ctrl.dismissInfo = function() {
      ctrl.infoMessage = null;
    };

    // ---------
    // SELECTORS
    // ---------

    // select setcion of the import
    ctrl.selectSection = function (section) {
      ctrl.selectedSection = section;
      userCache.put('importSelectedSection', section);
    };

    // -------------------
    // BREADCRUMB & RESETS
    // -------------------

    ctrl.checkBreadcrumb = function (name) {
      return (angular.isDefined(ctrl.selectedSection) ? 
        ctrl.selectedSection === name : (name === 'all' ? true : false));
    };

    ctrl.showAll = function () {
      ctrl.selectedSection = 'all';
      userCache.put('importSelectedSection', 'all');
    };
    
    // -----------
    // IMPORT DATA
    // -----------

    ctrl.importData = function (event) {
      ctrl.dismissError();
      ctrl.dismissInfo();
      var f = event.target.files[0],
          r = new FileReader();
      r.onloadend = function (e) {
        var data = e.target.result;
        switch (f.type) {
          case 'text/csv':
          case 'attachment/csv':
            prepareData(data, 'text/csv');
            break;
          case 'application/json':
          case 'attachment/json':
            prepareData(data, 'application/json');
            break;        
          default:
            $timeout(function() {
              ctrl.errorMessage = 'Could not import the data type as: ' + f.type + 
                '. Please use the following types of files: CSV/JSON';              
            });
            break;
        }
      };
      r.readAsBinaryString(f);
    };

    ctrl.applyData = function () {
      ctrl.dismissError();
      ctrl.dismissInfo();
      checkLogin().then(function (isLogged) {
        if (isLogged) {
          switch (ctrl.selectedSection) {
            case 'products':
              uploadProducts();
              break;
            case 'providers':
              uploadProviders();
              break;
            case 'prices':
              uploadPriceLines();
              break;
            default:
              break;
          }
        }
      });
    };

    ctrl.checkExistingProducts = function (item) {
      return _.findIndex(ctrl.data.products.exist, { 
        group: item.group,
        name: item.name
      });
    };

   ctrl.checkExistingProviders = function (item) {
      return _.findIndex(ctrl.data.providers.exist, { 
         name: item.name
      });
    };

    ctrl.checkExistingPriceLines = function (item) {
      return _.findIndex(ctrl.data.prices.exist, { 
        version: item.version,
        group: item.group,
        product: item.product,
        provider: item.provider,
        article: item.article,
        operation: item.operation,
        quantity: item.quantity
      });
    };

    ctrl.createProductsCsvTemplate = function () {
      var context = 'Group, Name, Provider, Unit, Tags, Article, Description\r\n' +
        "domains, com, verisign, year, 'gtld' 'tld' 'popular_en' 'popular_es' 'popular_nl', VCN123X, Commercial\r\n";
      exportService.saveBlob(new Blob([context], {type: "text/csv"}), 'products.csv');
    };

    ctrl.createProvidersCsvTemplate = function () {
      var context = 'Name, Article, Description\r\n' +
        'verisign, VCN, "VeriSign (.com/.net)"';
      sexportService.aveBlob(new Blob([context], {type: "text/csv"}), 'providers.csv');
    };

    ctrl.createPriceLinesCsvTemplate = function () {
      var price = [13.46, 10.46, 9.96, 9.46, 9.26, 8.96, 8.76, 8.66];
      var context = 'Version, Group, Product, Provider, Article, Operation, Quantity, Currency, Cost, Extras';
      ctrl.data.config.tiers.forEach(function(item) {
        context += ', Tier.' + item; 
      });
      context += '\r\n1, domains, com, verisign, default, create, 1, USD, 7.85, 0.21';
      ctrl.data.config.tiers.forEach(function(item, index) {
        context += ', ' + price[index]; 
      });
      exportService.saveBlob(new Blob([context], {type: "text/csv"}), 'prices.csv');
    };

    ctrl.createProductsJsonTemplate = function () {
      var context = [{
        group: 'domains',
        name: 'com',
        provider: 'verisign',
        unit: 'year',
        tags: ['gtld', 'tld', 'popular_en', 'popular_es', 'popular_nl'],
        article: 'VC123X',
        description: 'Commercial',
     }];
      exportService.saveBlob(new Blob([JSON.stringify(context)], {type: "application/json"}), 'products.json');
    };

    ctrl.createProvidersJsonTemplate = function () {
      var context = [{
        name: 'verisign',
        article: 'VCN',
        description: 'VeriSign (.com/.net)',
     }];
      exportService.saveBlob(new Blob([JSON.stringify(context)], {type: "application/json"}), 'providers.json');
    };

    ctrl.createPriceLinesJsonTemplate = function () {
      var price = [13.46, 10.46, 9.96, 9.46, 9.26, 8.96, 8.76, 8.66];
      var context = [{
        version: 1,
        group: 'domains',
        product: 'com',
        provider: 'verisign',
        article: 'default',
        operation: 'create',
        quantity: 1,
        currency: 'USD',
        cost: 7.85,
        extras: 0.21,
        tier: {}
      }];
      ctrl.data.config.tiers.forEach(function(item, index) {
        context[0].tier[item] = price[index];
      });
      exportService.saveBlob(new Blob([JSON.stringify(context)], {type: "application/json"}), 'prices.json');
    };
    
    function uploadProducts() {
      b17Service.uploadProducts(ctrl.data.products.upload, {
        token: auth.getToken(),
      }).then(function (response) {
        if (response.data && response.data.data && response.data.data.success ) {
          ctrl.data.products.upload = [];
          ctrl.data.products.exist = [];
          ctrl.infoMessage = 'The products were imported successfully';
          // renew products
          b17Service.getResponse().then(function (response) {
            b17Service.getProducts({
              cache: false
            });
            ctrl.data.groups.forEach(function (item) {
              b17Service.getProducts({
                cache: false,
                group: item.name
              });
            });
          });
        } else {
          checkErrorCodeMessage();
        }
      });
    }
        
    function uploadProviders() {
      b17Service.uploadProviders(ctrl.data.providers.upload, {
        token: auth.getToken(),
      }).then(function (response) {
        if (response.data && response.data.data && response.data.data.success ) {
          ctrl.data.providers.upload = [];
          ctrl.data.providers.exist = [];
          ctrl.infoMessage = 'The providers were imported successfully';
          // renew providers
          b17Service.getResponse().then(function (response) {
            b17Service.getProviders({
              cache: false
            });
          });
        } else {
          checkErrorCodeMessage();
        }
      });
    }

    function uploadPriceLines() {
      b17Service.uploadPrices(ctrl.data.prices.upload, {
        token: auth.getToken(),
      }).then(function (response) {
        if (response.data && response.data.data && response.data.data.success ) {
          ctrl.data.prices.upload = [];
          ctrl.data.prices.exist = [];
          ctrl.infoMessage = 'The prices were imported successfully';
          // renew prices
          b17Service.getResponse().then(function (response) {
            ctrl.data.versions.forEach(function (item) {
              b17Service.getPrices({
                cache: false,
                version: item.number,
                legacy: 'true',
              });
            });
          });
        } else {
          checkErrorCodeMessage();
        }
      });
    }

    function prepareData(data, contentType) {
      switch (ctrl.selectedSection) {
        case 'products':
          b17Service.checkProducts(data, {
            headers: {
              "Content-type": contentType
            }
          }).then(function (response) {
            if (response.data && response.data.data && response.data.data.success ) {
              ctrl.data.products.upload = response.data.data.results;
              ctrl.data.products.exist = response.data.data.updates;
            } else {
              checkErrorCodeMessage();
            }
          });
          break;
        case 'providers':
          b17Service.checkProviders(data, {
            headers: {
              "Content-type": contentType
            }
          }).then(function (response) {
            if (response.data && response.data.data && response.data.data.success ) {
              ctrl.data.providers.upload = response.data.data.results;
              ctrl.data.providers.exist = response.data.data.updates;
            } else {
              checkErrorCodeMessage();
            }
          });
          break;
        case 'prices':
          b17Service.checkPrices(data, {
            headers: {
              "Content-type": contentType
            }
          }).then(function (response) {
            if (response.data && response.data.data && response.data.data.success ) {
              ctrl.data.prices.upload = response.data.data.results;
              ctrl.data.prices.exist = response.data.data.updates;
            } else {
              checkErrorCodeMessage();
            }
          });
          break;
        default:
          break;
      }
    }
        
    // -----------------
    // SERVICE FUNCTIONS
    // -----------------

    // check login
    function checkLogin() {
      return auth.checkUserData().then(function(userData) {
        if (userData.UID) {
          return true;
        } else {
          $aside.open({
            templateUrl: 'components/auth/login-form.html',
            placement: 'right',
            size: 'sm',
            backdrop: true,
            controller: 'loginFormCtrl'
          }).result.then(function (message) {
            console.log(message);
          });
          return false;
        }
      });   
    }

    function checkErrorCodeMessage() {
      if (userCache.get('lastErrorCode')) {
        ctrl.errorMessage = 'Error: (' + userCache.get('lastErrorCode') + ') ' + userCache.get('lastErrorMessage');
      } else {
        ctrl.errorMessage = 'Unknown error, please check connection to the service.';
      }
    }

    // -------------------------------------------
    // EXPORT TO CSV, created by Eugene Semennikov
    // -------------------------------------------

    ctrl.exportAllProductRecordsToCsv = exportToCsv.downloadAllProductRecordsToFile;

  });

})();
